export enum SearchDataLoadTypeEnum {
  RESULTS = 'results',
  FACETS = 'facets'
}
